<template>
  <div class="spotchecksearch">
    <my-head :title="title+'记录'"/>
    <mu-text-field v-model="searchVal" @blur="" placeholder="搜索" ref="vin" class='input auto-width' @keyup.enter.native="search"><i class="iconfont icon-search" @click="search"></i></mu-text-field>
    <mu-container ref="container" class="demo-loadmore-content">
      <mu-load-more @refresh="refresh" :refreshing="refreshing" :loading="loading" @load="load">
        <div v-for="item in list">
          <div class="scs-list" @click="goInfo(item)">
            <div class="gb-row">
              <div class="grid-cell t1">VIN</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.vin"></mu-text-field></div>
            </div>

            <div class="gb-row">
              <div class="grid-cell t1">点检日期</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.checkDate"></mu-text-field></div>
            </div>

            <div class="gb-row">
              <div class="grid-cell t1">相关单号</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.ASNcode"></mu-text-field></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell t1">公里数</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.mile"></mu-text-field></div>
            </div>

            <div class="gb-row">
              <div class="grid-cell t1">高压电量</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.highEectricity"></mu-text-field></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell t1">低压电量</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.lowEectricity"></mu-text-field></div>
            </div>

            <div class="gb-row">
              <div class="grid-cell t1">遥控钥匙数目</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.remoteKeyNum"></mu-text-field></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell t1">机械钥匙数目</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.mechanicalKeyNum"></mu-text-field></div>
            </div>

            <div class="gb-row">
              <div class="grid-cell"><mu-checkbox :disabled="true" v-model="item.isHighEectricity" value="涉及高压电" label="涉及高压电"></mu-checkbox></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell"><mu-checkbox :disabled="true" v-model="item.isLowEectricity" value="涉及低压电" label="涉及低压电"></mu-checkbox></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell"><mu-checkbox :disabled="true" v-model="item.isAttachmentFinish" value="附件袋是否完整" label="附件袋是否完整"></mu-checkbox></div>
            </div>
            <div class="gb-row">
              <div class="grid-cell t1">质损情况</div>
              <div class="grid-cell"><mu-text-field :disabled="true" v-model="item.qcRemark"></mu-text-field></div>
            </div>
          </div>
        </div>
      </mu-load-more>
    </mu-container>
  </div>
</template>

<script>
import myHead from '@/components/header'
import api from '@/common/api'
import scanning from '@/components/scanning'
export default {
  name: 'pickcar',
  components: {
    myHead, scanning
  },
  data () {
    return {
      pageCurrent: 1,
      title: '点检搜索',
      searchVal: '',
      num: 20,
      refreshing: false,
      loading: false,
      text: 'List',
      type: '',
      requestOnce: true,
      list: [
        // {
        //   highEectricity: 33,
        //   id: 1,
        //   isAttachmentFinish: true,
        //   isHighEectricity: true,
        //   isLowEectricity: true,
        //   lowEectricity: 33,
        //   mile: 33,
        //   qcRemark: "321",
        //   vin: "WAUAGCF42MA018301",
        // }
      ]
    }
  },
  methods: {
    goInfo (item) {
      this.$router.push({ path: '/spotchecklist', query: {type: this.title, info: item}})
    },
    search () {
      this.pageCurrent = 1
      this.getData()
    },
    getData () {
      this.Toast.loading({message: '查询中'})
      let data = Object.assign({}, this.$store.state.user, {
        content: {
          searchVal: this.searchVal,
          pageCurrent: this.pageCurrent,
          code: this.type
        }
      })
      console.log('data', JSON.stringify(data))
      /* 发送post请求 */
      if (this.requestOnce) {
        this.requestOnce = false
        this.common.reqData(api.app('checkRecordGetByType'), data, res => {
          this.requestOnce = true
          this.loading = false
          this.Toast.clear()
          console.log('Q返回数据：', JSON.stringify(res.data))
          if (res.data.status == 100) {
            if (res.data.content.list) {
              this.list = this.pageCurrent === 1 ? res.data.content.list : this.list.concat(res.data.content.list)
              this.pageCurrent++
            }
          } else {
            this.Toast({
              mask: true,
              message: res.data.msg
            })
          }
        }, err => {
          this.loading = false
          this.requestOnce = true
          this.Toast.clear()
          // 提示
          this.Toast({
            mask: true,
            message: '请求超时，检查你的网络或稍后再试'
          })
          console.log(err)
        })
      }
    },
    refresh () {
      // 刷新
      this.refreshing = true
      this.$refs.container.scrollTop = 0
      setTimeout(() => {
        this.refreshing = false
        this.text = this.text === 'List' ? 'Menu' : 'List'
        this.num = 10
      }, 2000)
    },
    load () {
      // 加载
      this.loading = true
      this.requestOnce && this.getData()
    }
  },
  mounted () {
    this.title = this.$route.query.type || '点检'
    if (this.title == '到港点检') {
      this.type = 'DGDJ'
    } else if (this.title == '出库点检') {
      this.type = 'CKDJ'
    } else if (this.title == '入库点检') {
      this.type = 'RKDJ'
    }
    this.getData()
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.auto-width{
  width: 95%;
  margin: 10px auto;
}
.scs-hr{
  margin: 15px 0;
}
.scs-list{
  width: 100%;
  align-items: flex-end !important;
  background: #efefef;
  padding: 10px;
  margin-bottom: 25px;
}
.input{
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
.mu-list>li{
  margin: 0 0 25px 0;
}
.scs-list .mu-input,
#mytable .mu-input{
  width: 100%;
  margin: 0;
}
.gb-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.spotcheck-btns{
  display: flex;
  width: 85%;
  margin-top: 20px;
  justify-content: space-between;
}
.spotcheck-btns button{
  margin: 0 0;
}
.photos{
    border: 1px solid #ccc;
    width: 90%;
    margin: 20px auto 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
i.iconfont.icon-icon25201{
    display: block;
    font-size: 50px;
    margin: 10px;
}
#app .mu-item{
  flex-wrap: wrap;
}
.grid-cell.t1{
  width: 100px;
  margin-right: 10px;
}
.grid-cell.t2{
  width: 100px;
  margin-left: 10px;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/spotcheck/spotchecksearch.vue